<div class="rv-grow rv-grid rv-column-12">
  <deprecated-text-field
    class="rv-column-12 mb-small"
    [required]="true"
    [label]="'Address line 1'"
    [ngModel]="value.address1"
    (ngModelChange)="value.address1 = $event; fireValueChange()"
  ></deprecated-text-field>
  <deprecated-text-field
    class="rv-column-12 mb-small"
    [label]="'Address line 2'"
    [ngModel]="value.address2"
    (ngModelChange)="value.address2 = $event; fireValueChange()"
  ></deprecated-text-field>
  <deprecated-text-field
    class="rv-column-6 rv-column-6-medium rv-column-12-small mr-small"
    [required]="true"
    [label]="'City'"
    [ngModel]="value.city"
    (ngModelChange)="value.city = $event; fireValueChange()"
  ></deprecated-text-field>
  <select-dropdown
    class="rv-column-3 rv-column-6-medium rv-column-12-small mr-small"
    [required]="true"
    label="State"
    [filterable]="true"
    [options]="states | stringoptions: 'as-is' : 'upper-all'"
    [selectedOptionId]="value.state"
    (selectedOptionIdChange)="value.state = $event; fireValueChange()"
  ></select-dropdown>
  <deprecated-text-field
    class="rv-column-3 rv-column-6-medium rv-column-12-small mr-small"
    [required]="true"
    [label]="'Zip'"
    [ngModel]="value.zip"
    (ngModelChange)="value.zip = $event; fireValueChange()"
    [maxLength]="5"
    [minLength]="5"
  ></deprecated-text-field>
</div>
